import { DocumentOrganizationKeys, GoalFilterDocument } from '@griply/types';
import { GroupByMode } from 'shared/types/sorting-mode';

export const defaultFilterDocument: GoalFilterDocument = {
  [DocumentOrganizationKeys.SortingMode]: null,
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.None,
  [DocumentOrganizationKeys.Filters]: {},
  [DocumentOrganizationKeys.CollapsedSections]: [],
};
